import Box from "@mui/material/Box";
import { styled } from "@mui/system";

export const Page = styled(Box)(() => ({
  width: "100%",
  height: " 100%",
  padding: "22px 0px 0px 113px",
  ".filterBox": {
    height: "40px",
    width: "40px",
    boxShadow: "0px 4px 4px rgba(48, 111, 188, 0.2)",
    borderRadius: "8px",
  },
}));
